import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CosFiChart from "../components/CosFiChart";
import CosfiReportDialog from "../components/CosfiReportDialog";

function CosfiPage({ deviceType = "analyzer" }) {
  const { t } = useTranslation();
  const { deviceId } = useParams();
  const [cosfiData, setCosfiData] = useState([]);
  const [range, setRange] = useState("1D");
  const [reportOpen, setReportOpen] = useState(false);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const ENDPOINT_PREFIX =
    deviceType === "gruparge"
      ? "/gruparge"
      : deviceType === "reactive"
        ? "/reactive"
        : "/measurements";

  function getRangeMs(r) {
    switch (r) {
      case "1H": return 1 * 60 * 60 * 1000;
      case "3H": return 3 * 60 * 60 * 1000;
      case "6H": return 6 * 60 * 60 * 1000;
      case "12H": return 12 * 60 * 60 * 1000;
      case "1D": return 1 * 24 * 60 * 60 * 1000;
      case "3D": return 3 * 24 * 60 * 60 * 1000;
      case "1W": return 7 * 24 * 60 * 60 * 1000;
      default: return 1 * 24 * 60 * 60 * 1000;
    }
  }

  async function fetchCosfi() {
    try {
      const end = new Date();
      const start = new Date(end.getTime() - getRangeMs(range));
      const url = `${API_BASE}${ENDPOINT_PREFIX}/cosfi?deviceId=${deviceId}&start=${start.toISOString()}&end=${end.toISOString()}`;
      const res = await fetch(url);
      const rows = await res.json();
      setCosfiData(rows.map(r => ({
        time: new Date(r.time).getTime(),
        CosFi1: r.CosFi1,
        CosFi2: r.CosFi2,
        CosFi3: r.CosFi3,
        CosFiT: r.CosFiT,
      })));
    } catch (err) {
      console.error("fetchCosfi error:", err);
    }
  }

  useEffect(() => {
    if (!deviceId) return;
    fetchCosfi();
    const i = setInterval(fetchCosfi, 5000);
    return () => clearInterval(i);
  }, [API_BASE, deviceId, range]);

  return (
    <div className="p-4 md:p-6 grid grid-cols-1 gap-6">
      <div className="bg-white rounded-2xl shadow-md p-4 md:p-6 flex flex-col">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">{t('cosfi.title')}</h2>
        <CosFiChart
          data={cosfiData}
          range={range}
          onRangeChange={setRange}
          type="cosfi"
          deviceType={deviceType}
        />
      </div>
      <div className="flex items-center justify-start mb-2">
        <button
          onClick={() => setReportOpen(true)}
          className="bg-sky-600 text-white px-3 py-2 rounded-md hover:bg-sky-700 text-sm"
        >
          {t('cosfi.reportButton')}
        </button>
      </div>

      <CosfiReportDialog
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        deviceId={deviceId}
        deviceType={deviceType}
        API_BASE={API_BASE}
      />
    </div>
  );
}

export default CosfiPage;
